import { product, radarOptions } from './base';
import { Weblog } from '@ks/weblogger/lib/log.browser';
import Radar from '@ks/weblogger/lib/plugins/radar';
export default function (options) {
    return new Weblog({
        // @ts-ignore
        env: options.env,
        // 配置插件
        plugins: [
            new Radar({
                ...radarOptions,
                projectId: options.radarId || radarOptions.projectId,
            }),
        ],
        attachUrl: true,
    }, {
        product_name: product, // 业务线
    });
}
